import { FormControl, FormErrorMessage, FormLabel, Select } from '@chakra-ui/react';
import { Api } from 'api';
import React from 'react';
import { useQuery } from 'react-query';
import { Country } from 'types';

export interface CountrySelectProps {
  label?: string;
  value: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  label = 'Ülke',
  value,
  name,
  onChange,
  error,
  helperText,
  disabled = false,
}) => {
  const { data: countries, isLoading } = useQuery<Country[]>(
    'countries',
    async () => {
      const response = await Api.Location.getCountries();
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  return (
    <FormControl isInvalid={error}>
      <FormLabel>{label}</FormLabel>
      <Select name={name} value={value} onChange={onChange} disabled={disabled || isLoading} placeholder="Ülke seçiniz">
        {countries?.map((country) => (
          <option key={country.id} value={country.id}>
            {country.name}
          </option>
        ))}
      </Select>
      {helperText && <FormErrorMessage>{helperText}</FormErrorMessage>}
    </FormControl>
  );
};
